import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Add from '../pages/add/Add.js';
import {Drop} from "../pages/drops-list/Drop.jsx";
import {Availability} from "../pages/availability/Availability.jsx";
import {Balance} from "../pages/balance/Balance.jsx";
import {MainMenu} from "../shared/MainMenu.jsx";
import {DropsList} from "../pages/drops-list/List.jsx";
import {DeliveryOrdersList} from "../pages/delivery-orders/DeliveryOrdersList.jsx";
import {DeliveryOrder} from "../pages/delivery-orders/Order.jsx";


const AppRoutes = () => {
  return (
    <Router>

      <MainMenu />

      <Routes>
        <Route path="/" element={<DropsList />} />
        <Route path="/add" element={<Add />} />
        <Route path="/availability" element={<Availability />} />
        <Route path="/balance" element={<Balance />} />
        <Route path="/drop/:id" element={<Drop />} />
        <Route path="/delivery-orders" element={<DeliveryOrdersList />} />
        <Route path="/delivery-orders/:id" element={<DeliveryOrder />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
